import { Clock, Volume2 } from "lucide-react";
import { Button } from "@/components/ui/button";
const HOTMART_CHECKOUT_URL = "https://pay.hotmart.com/X103718093T?checkoutMode=10";
const VideoSection = () => {
  const handleBuyClick = () => {
    window.open(HOTMART_CHECKOUT_URL, "_blank");
  };
  return <section className="relative overflow-hidden section-padding bg-muted/30">
      {/* Background dots pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
        backgroundImage: `radial-gradient(circle, rgba(255,255,255,0.3) 1px, transparent 1px)`,
        backgroundSize: "20px 20px"
      }} />
      </div>
      <div className="container-centered relative z-10 text-secondary-foreground">
        {/* Section Header */}
        <div className="mb-6 sm:mb-10 text-center">
          <span className="inline-block rounded-full bg-gradient-to-r from-teal-500 via-cyan-400 to-amber-500 px-4 py-2 text-slate-900 font-extrabold text-2xl">
            Video Explicativo
          </span>
          <h2 className="mt-4 font-display text-2xl font-bold text-foreground sm:text-3xl lg:text-4xl">
            Mira Cómo Funciona <span className="bg-gradient-to-r from-teal-400 via-cyan-300 to-amber-400 bg-clip-text text-transparent">(2 Minutos)</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl font-bold text-xl text-secondary-foreground">
            En este video te muestro qué incluye el sistema, para quién es y si es para ti antes de comprar.
          </p>
        </div>

        {/* Video Container */}
        <div className="mx-auto max-w-sm px-2 sm:px-0">
          <div className="relative overflow-hidden rounded-2xl bg-card shadow-card">
            {/* Video Placeholder with Thumbnail */}
            <div className="relative aspect-[9/16] bg-black">
              {/* Poster image loads first for faster LCP */}
              <video className="h-full w-full object-contain" poster="/images/video-poster-main-352.webp" controls playsInline preload="none" width="334" height="594">
                <source src="/videos/video-explicativo.mp4" type="video/mp4" />
                Tu navegador no soporta el elemento de video.
              </video>
            </div>

            {/* Video Info Bar */}
            <div className="flex items-center justify-between border-t border-border bg-card px-4 py-3 sm:px-6">
              <div className="flex items-center gap-4 text-sm text-muted-foreground">
                <span className="flex items-center gap-1">
                  2:00
                  <Clock className="h-4 w-4" />
                </span>
                <span className="flex items-center gap-1">
                  <Volume2 className="h-4 w-4" />
                  En Español
                </span>
              </div>
              <span className="text-sm font-medium text-center text-secondary-foreground">
                Video explicativo del sistema completo
              </span>
            </div>
          </div>

          {/* CTA después del video */}
          <div className="mt-8 btn-container">
            <Button onClick={handleBuyClick} size="lg" className="btn-cta relative h-14 bg-gradient-to-r from-teal-500 via-cyan-400 to-amber-500 px-8 text-base font-bold text-slate-900 shadow-[0_0_30px_rgba(20,184,166,0.4)] transition-all hover:scale-105 sm:h-16 sm:px-12 sm:text-lg">
              
              <span className="text-center whitespace-normal text-xl">SÍ, QUIERO TOMAR CONTROL DE MI CRÉDITO – $16.99</span>
            </Button>
            <p className="mt-3 text-muted-foreground text-xl font-extrabold">Acceso inmediato · Garantía 60 días 
· Sin llamadas ni contratos</p>
          </div>
        </div>
      </div>
    </section>;
};
export default VideoSection;